import React, { useMemo } from 'react';
import cx from 'classnames';
import { isRtlLanguage } from 'helpers/isRtlLanguage';
import PropTypes from 'prop-types';

import { IntlManager, useSettings } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

import { CDN_TYPE_BASE, imageUrlCDN } from 'common/utils';

const PaymentMethodItem = ({ amount, depositBonuses, paymentMethod, showAmount }) => {
  const { desktopImageLink, id, maxAmount, minAmount, name } = paymentMethod ?? {};
  const { lang } = useSettings();

  const imageStyle = useMemo(() => {
    const style = {};
    if (desktopImageLink) {
      style.backgroundImage = `url(${imageUrlCDN(desktopImageLink, CDN_TYPE_BASE)})`;
    }

    return style;
  }, [desktopImageLink]);

  const showBonusSign = useMemo(() => {
    const availableBonuses = depositBonuses?.filter(bonus => {
      const notAllowedPaymentMethods = bonus?.basicLimit.notAllowedPaymentMethods;
      return !notAllowedPaymentMethods.map(methodId => parseInt(methodId)).includes(parseInt(id));
    });

    return !!availableBonuses?.length;
  }, [depositBonuses, id]);

  const renderAmount = (label, amount, cls) => {
    const amountBoxCls = cx('profile-payments-item-amount', cls);
    return (
      <div className={amountBoxCls}>
        <Label className="profile-payments-item-amount__key" message={label} />
        <div className="profile-payments-item-amount__value">{IntlManager.formatMoney(amount)}</div>
      </div>
    );
  };

  const isShowMinMaxAmount = !!(minAmount && maxAmount);

  return (
    <div className="profile-payments-item">
      <div className="profile-payments-item__box">
        {showBonusSign && (
          <div className={cx('profile-payments-item-icon', { rtl: isRtlLanguage({ lang }) })}>
            <Icon name="payment-atom" />
          </div>
        )}
        <div className="profile-payments-item__logo" style={imageStyle}>
          {!desktopImageLink && <Icon name="money" />}
        </div>
      </div>
      <div className="profile-payments-item__info">
        <div className="profile-payments-item__name">{name}</div>
        {showAmount ? (
          renderAmount('profile_amount', amount, 'profile-payments-item-amount-big')
        ) : isShowMinMaxAmount ? (
          <>
            {renderAmount('profile_min_amount', minAmount, 'profile-payments-item-amount-big')}
            {renderAmount('profile_max_amount', maxAmount)}
          </>
        ) : null}
      </div>
    </div>
  );
};

PaymentMethodItem.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  depositBonuses: PropTypes.arrayOf(PropTypes.object),
  paymentMethod: PropTypes.object,
  showAmount: PropTypes.bool,
};

export default PaymentMethodItem;
